import { getRoutes } from '@ui-framework/index';
import AuthorizationWrapper, {
  authFnAllowOnlySAForMaintenance,
} from '@product-framework/components/AuthorizationWrapper';
import IndustryEdit from './pages/edit/index';
import IndustryCreate from './pages/create/index';
import IndustryList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import IndustryFormStore from './store/index';

const Pages = ProtectedRoute => ({
  IndustryEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={IndustryEdit}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
  IndustryCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={IndustryCreate}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
  IndustryList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={IndustryList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  { industryFormStore: new IndustryFormStore(rootStore) },
];

export { IndustryEdit, IndustryCreate, IndustryList, routes, stores };
